<template>
  <v-row>
    <v-col cols="12" md="6" class="d-flex flex-column justify-center align-center">
      <!-- <v-badge inline color="red" :content="today_confirmed"> -->
      <span :class="[count]"><ICountUp :endVal="importAmount"/></span>
      <!-- </v-badge> -->

      <span :class="[title]">进口金额（亿美元）</span>
    </v-col>
    <v-col cols="12" md="6" class="d-flex flex-column justify-center align-center">
      <!-- <v-badge inline color="green" :content="today_recovered"> -->
      <span :class="[count]"><ICountUp :endVal="exportAmount"/></span>
      <!-- </v-badge> -->

      <span :class="[title]">出口金额（亿美元）</span>
    </v-col>
    <!-- <v-col cols="12" md="4" class="d-flex flex-column justify-center align-center">
      <v-badge inline color="pink" :content="today_death">
        <span :class="[count]"><ICountUp :endVal="deaths"/></span>
      </v-badge>
      <span :class="[title]">种类</span>
    </v-col> -->
  </v-row>
</template>

<script>
import ICountUp from 'vue-countup-v2';

export default {
  props: [
    'importAmount',
    'exportAmount',
    'deaths',
    'today_confirmed',
    'today_recovered',
    'today_death'
  ],
  components: {
    ICountUp
  },
  computed: {
    count() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return 'display-2 font-weight-bold';
      }

      return 'display-1 font-weight-bold';
    },
    title() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return 'mt-4 title';
      }

      return 'mt-4 subtitle-1';
    }
  }
};
</script>
